import { render, staticRenderFns } from "./RecipeTabsCreate.vue?vue&type=template&id=736791d7&"
import script from "./RecipeTabsCreate.vue?vue&type=script&lang=js&"
export * from "./RecipeTabsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports